import React from "react";
import Messages from "../../Chat/Messages";
import { Event } from "../Events";

interface EventChatProps {
  eventData: Event;
}

const EventChat: React.FC<EventChatProps> = ({ eventData }) => {
  return <Messages contextId={eventData.event_id} context="Event" />;
};

export default EventChat;
